export const navData = [
  {
    name: "Home",
    to: "/",
  },
  {
    name: "About Us",
    to: "/about",
  },
  {
    name: "Facts & Figures",
    to: "/facts-and-figures",
  },
  {
    name: "News & Updates",
    to: "/news-and-updates",
  },
  {
    name: "Careers",
    to: "/jobs",
  },
  {
    name: 'Scholarships',
    to: '/scholarships'
  },
  {
    name: "Contact us",
    to: "/contact",
  },
  {
    name: "Maui Harvest",
    to: "/maui-harvest",
  },
]
